exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\r\n  padding: 15px 16px;\r\n  /* position: fixed; */\r\n  bottom: 0px;\r\n  width: 100%;\r\n  z-index: 1000;\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\r\n", ""]);

// exports
